import { Class } from '../models/Class';

export const sortClassesList = (classes: Class[]) => {
  const sorted = [...classes].sort((a, b) => {
    if (a.sectionName && b.sectionName) {
      if (a.sectionName.toLowerCase() > b.sectionName.toLowerCase()) {
        return 1;
      }
      if (a.sectionName.toLowerCase() < b.sectionName.toLowerCase()) {
        return -1;
      }
      return 0;
    }
    return 0;
  });
  return sorted;
};
